module.exports = __webpack_public_path__ + "img/home-section1-0.c9426afd.png";